<template>
  <section v-if="hasOptionalAddOn && isPickLottery" class="results-winning-combinations">
    <h3 class="caption-regular mb-100">
      {{
        $t('results.winningcombinations.headline', {
          addOn: $t(`lottery.addon.${optionalAddOn?.name}`),
        })
      }}
    </h3>

    <ul class="flex flex-wrap gap-y-100 gap-x-200">
      <li v-for="(winningCombination, index) in winningCombinations" :key="index">
        <LineItem
          v-bind="{ addOns, licensedTerritory, lotteryId }"
          class="line-item"
          :fields="getLotteryNumberFields(winningCombination)"
          highlight-add-on
          spacing="small"
        />
      </li>
    </ul>
  </section>
</template>

<script lang="ts" setup>
const { addOns, drawnNumbers, hasOptionalAddOn, licensedTerritory, lotteryId, optionalAddOn } =
  await useResultDetails()

const { isPickLottery } = useLotteryType(lotteryId)

const winningCombinations = computed(() =>
  drawnNumbers.value[0].numbers
    .filter(({ name }) => name.toLowerCase() !== optionalAddOn.value?.name.toLowerCase())
    .map((_, index, numbers) => {
      const addOn = drawnNumbers.value[0].numbers.find((field) => !/^[A-Z]{1}$/.test(field.name))

      const winningCombination = [...numbers]
      winningCombination[index] = {
        ...numbers[index],
        name: addOn?.name ?? '',
        values: addOn?.values || [],
      }

      return winningCombination
    }),
)
</script>

<style lang="scss" scoped>
.results-winning-combinations {
  .line-item {
    :deep(img) {
      display: none;
    }
  }
}
</style>
